(() => {
  angular
    .module('app')
    .controller('host.views.employees.insurerPlanModal', InsurerPlanController);

  InsurerPlanController.$inject = [
    '$uibModalInstance',
    'insurer'
  ];

  function InsurerPlanController(
    $uibModalInstance,
    insurer,
  ) {
    const vm = this;
    vm.loading = 0;

    vm.getPlanDetails = getPlanDetails;
    vm.insurer = insurer
    vm.benefits = [];
    
    function init() {
      getPlanDetails();
    }

    function getPlanDetails() {
      const planSettings = typeof vm.insurer.planSettings === 'string' 
      ? JSON.parse(vm.insurer.planSettings) 
      : vm.insurer.planSettings;

      vm.benefits = planSettings.principalScheduleOfBenefit.map(item => ({
        name: `${formatNodeCode(item.nodeCode)}`,
        category: item.remarks, // TODO HM-10233: Placeholder value for now.
        type: 'Daily', // TODO HM-10233: Placeholder value for now.
        paymentType: 'Cashless', // TODO HM-10233: Placeholder value for now.
        amount: item.isAsCharged ? 'As charged' : item.amount
      }));
    }

    function formatNodeCode(code) {
      return code.replace(/([A-Z])/g, ' $1').trim();
    }

    vm.close = function close() {
      $uibModalInstance.close();
    };

    init();
  }
})();
